<!-- @format -->

@for (ongoingTermRegistrationPeriod of ongoingTermRegistrationPeriods$ | async; track ongoingTermRegistrationPeriod) {
  <div class="row alert-top-spacing">
    <div class="col-md-12">
      <sis-contextual-notification variant="warning">{{
        ongoingTermRegistrationPeriod?.registrationInfo | localizedString
      }}</sis-contextual-notification>
    </div>
  </div>
}
@for (neglectedTermRegistrationPeriod of this.neglectedTermRegistrationPeriods$ | async; track neglectedTermRegistrationPeriod) {
  <div class="row alert-top-spacing">
    <div class="col-md-12">
      <sis-contextual-notification variant="danger">{{
        neglectedTermRegistrationPeriod?.studyRightRecoveryInfo | localizedString
      }}</sis-contextual-notification>
    </div>
  </div>
}
